// V8 doesn't change JMS schema. It changes some internal PHX type validation in v0.30.0
export const migrateToV8 = (state)=>state;

//# sourceMappingURL=v08.js.map